export default __webpack_public_path__ + "static/media/7.3d1f27cf.jpg";